
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.029 5.352c-.016 1.002-.349 2.359-1.912 2.885.49-1.164.564-2.278.218-3.32-.464-1.398-2.01-2.49-3.038-3.084-.352-.204-.802.049-.796.455.014.741-.212 1.825-1.306 2.919C2.738 6.663 2 8.167 2 9.678 2 11.575 3.333 14 6 14c-2.694-2.694-.667-4.989-.667-4.989C5.897 12.954 8.66 14 10 14c1.14 0 3.333-.833 3.333-4.299 0-2.088-.888-3.674-1.59-4.599-.231-.305-.709-.132-.714.25z","fill":"#DB2434"}})])
          )
        }
      }
    